/* YOGUPO レビュー自作表示 v4（2026-07-07・設計班確定仕様）
   二階調の星 / 平均は部分星で正確に / きびしめの声=★3以下フィルタ /
   ネガタグ「お値段のこと」を並びに / 正直なリード文 / 分布バー絞り込み / おすすめ・あたらしい順 */
(function () {
  var root = document.getElementById("yg-reviews");
  if (!root) return;
  var R = [], S = {}, starSel = 0, topicSel = "すべて", sort = "reco", shown = 4;
  var NEG = { "お値段のこと": 1 };            // ネガ寄り＝閾値3で出す
  var HARSH = "正直な声";                      // ★3以下の絞り込み（上から目線を避けた呼び名）

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function stars(n) {   // 整数スコア（カード）：塗り＋空の二階調
    var h = "";
    for (var i = 0; i < 5; i++) h += '<span class="yg-' + (i < n ? "sf" : "se") + '">★</span>';
    return h;
  }
  function starbar(avg) {   // 平均（サマリー/ミニ証明）：部分塗りで正確に
    var pct = Math.max(0, Math.min(100, avg / 5 * 100)).toFixed(1);
    return '<span class="yg-starbar"><span class="yg-starbar-bg">★★★★★</span>' +
           '<span class="yg-starbar-fill" style="width:' + pct + '%">★★★★★</span></span>';
  }
  function jdate(d) { return d.replace(/-/g, "."); }

  function ordered() {
    var list = R.slice();
    if (sort === "new") list.sort(function (a, b) { return a.d < b.d ? 1 : -1; });
    else list.sort(function (a, b) {
      var pa = (a.pin ? 2 : 0) + (a.p ? 1 : 0), pb = (b.pin ? 2 : 0) + (b.p ? 1 : 0);
      if (pa !== pb) return pb - pa;
      return a.d < b.d ? 1 : -1;
    });
    return list;
  }
  function filtered() {
    return ordered().filter(function (r) {
      if (starSel && r.s !== starSel) return false;
      if (topicSel === HARSH) return r.s <= 3;
      if (topicSel === "写真つき") return !!r.p;
      if (topicSel !== "すべて" && (r.t || []).indexOf(topicSel) < 0) return false;
      return true;
    });
  }

  function bodyHtml(r) {
    var b = esc(r.b);
    if (r.m) { var m = esc(r.m); b = b.replace(m, '<span class="yg-m">' + m + "</span>"); }
    return b;
  }
  function card(r, i) {
    var el = document.createElement("div");
    el.className = "yg-rev"; el.id = "yg-rev-" + i;
    var h = "";
    if (r.h) h += '<p class="yg-harsh-note">正直なお声も、ありがたく載せています</p>';
    h += '<div class="yg-rtop"><span class="yg-rstars">' + stars(r.s) + "</span>" +
         '<span class="yg-rdate">' + jdate(r.d) + "</span></div>" +
         '<div class="yg-rwho"><span class="yg-rname">' + esc(r.a) + " さん</span>" +
         (r.v ? '<span class="yg-vpill">購入済み</span>' : "") + "</div>" +
         '<p class="yg-rbody">' + bodyHtml(r) + "</p>";
    if (r.p) h += '<div class="yg-rpics">' + r.p.map(function (u) {
      return '<img loading="lazy" src="' + esc(u) + '" alt="お客様の写真">'; }).join("") + "</div>";
    // ★お店からの返信＝畳んでおく（見たい人だけ開く。長くしないため）
    if (r.r) {
      h += '<details class="yg-reply"><summary>お店からの返信を読む</summary>' +
           '<div class="yg-reply-body"><span class="yg-reply-who">YOGUPO より</span>' +
           esc(r.r).replace(/\n/g, "<br>") + "</div></details>";
    }
    el.innerHTML = h;
    var body = el.querySelector(".yg-rbody");
    requestAnimationFrame(function () {
      var lh = parseFloat(getComputedStyle(body).lineHeight) || 27;
      if (!r.pin && !r.m && body.scrollHeight > lh * 7.6) {
        body.classList.add("folded");
        var btn = document.createElement("button");
        btn.className = "yg-fold"; btn.textContent = "つづきを読む";
        btn.addEventListener("click", function () { body.classList.remove("folded"); btn.remove(); });
        body.after(btn);
      }
    });
    return el;
  }

  function leadText() {
    if (topicSel === "お値段のこと")
      return "「お値段・送料」にふれた声を、かくさず集めました。";
    if (topicSel === HARSH)
      return "気になった点にふれたお声も、そのまま並べています。";
    return "";
  }
  function render() {
    var list = filtered();
    var lead = root.querySelector(".yg-lead");
    var lt = leadText();
    lead.textContent = lt; lead.style.display = lt ? "" : "none";
    var box = root.querySelector(".yg-list");
    box.innerHTML = "";
    if (!list.length) box.innerHTML = '<p class="yg-empty">この評価の声は、まだありません</p>';
    list.slice(0, shown).forEach(function (r, i) { box.appendChild(card(r, i)); });
    var mw = root.querySelector(".yg-morewrap");
    mw.innerHTML = "";
    if (list.length > shown) {
      var mb = document.createElement("button");
      mb.className = "yg-more"; mb.textContent = "のこり" + (list.length - shown) + "件の声を読む";
      mb.addEventListener("click", function () { shown += 10; render(); });
      mw.appendChild(mb);
    } else if (list.length && (topicSel !== "すべて" || starSel)) {
      var t = document.createElement("p");
      t.className = "yg-tail"; t.textContent = "この話題の声は、これでぜんぶです。";
      mw.appendChild(t);
    }
    var buy = document.createElement("button");
    buy.className = "yg-buy"; buy.textContent = "商品をえらぶ";
    buy.addEventListener("click", function () {
      var f = document.querySelector('form[action*="/cart/add"]');
      (f || document.body).scrollIntoView({ behavior: "smooth", block: "center" });
    });
    mw.appendChild(buy);
    var sp = root.querySelector(".yg-statewrap");
    sp.innerHTML = "";
    if (starSel) {
      var pill = document.createElement("button");
      pill.className = "yg-state";
      pill.textContent = "★" + starSel + "の声（" + list.length + "件）×";
      pill.addEventListener("click", function () { starSel = 0; shown = 4; syncDist(); render(); });
      sp.appendChild(pill);
    }
  }
  function syncDist() {
    var dist = root.querySelector(".yg-dist");
    dist.classList.toggle("has-sel", !!starSel);
    dist.querySelectorAll(".yg-drow").forEach(function (b) {
      b.classList.toggle("sel", Number(b.dataset.star) === starSel); });
  }

  // 全レビューを対象に（写真は先頭ソート＋「みんなの写真」帯で主役に）。
  // 旧=写真onlyだと、★分布バー(全108件で集計)と表示母集団(写真14件)がズレて「★2を押すと0件」バグ発生
  // ＝写真つきに★2/★3/★1が無いため。全件対象なら★どの評価も正しく絞れる（2026-07-09修正・要濱島さん承認）。
  var PHOTO_ONLY = false;
  function build(data) {
    R = data.reviews; S = data.stats;
    if (PHOTO_ONLY) R = R.filter(function (r) { return r.p && r.p.length; });
    var tcount = {};   // チップ件数は表示対象(R)から数え直す
    R.forEach(function (r) { (r.t || []).forEach(function (k) { tcount[k] = (tcount[k] || 0) + 1; }); });
    var maxd = Math.max.apply(null, Object.values(S.dist));
    var html =
      '<div class="yg-summary"><div class="yg-avg"><b>' + S.avg.toFixed(1) + "</b>" +
      "<div>" + starbar(S.avg) + "</div>" +
      '<div class="yg-n">' + S.total + "件のレビュー</div></div>" +
      '<div class="yg-dist">' + [5, 4, 3, 2, 1].map(function (s) {
        var n = S.dist[s] || 0;   // 0件の評価は押せない様に（disabled）＝「押しても空」を出さない
        return '<button type="button" class="yg-drow' + (n ? '' : ' yg-drow-0') + '" data-star="' + s + '"' + (n ? '' : ' disabled aria-disabled="true"') + '>' + s +
          '<span class="yg-dtr"><span class="yg-dfl" style="width:' + (maxd ? Math.round(n / maxd * 100) : 0) + '%"></span></span>' +
          '<span>' + n + "</span></button>";
      }).join("") + "</div></div>" +
      '<div class="yg-statewrap"></div>';
    // 写真帯
    var picRevs = R.filter(function (r) { return r.p; });
    if (!PHOTO_ONLY && picRevs.length) {
      html += '<p class="yg-strip-label">みんなの写真</p><div class="yg-strip">' +
        picRevs.map(function (r) {
          return '<img loading="lazy" data-ri="' + R.indexOf(r) + '" src="' + esc(r.p[0]) + '" alt="お客様の写真">';
        }).join("") + "</div>";
    }
    // チップ順: すべて→食いつき→お腹→お値段→きびしめ→お水→定期→シニア→写真つき
    var order = ["食いつき", "お腹の調子", "お水を飲まない子", "毎日の楽しみ", "トッピング・あげ方", "シニアの子", "多頭飼い", "定期便", "お値段のこと", HARSH];
    var chips = [["すべて", PHOTO_ONLY ? R.length : S.total]];
    var base = PHOTO_ONLY ? tcount : S.topics;
    order.forEach(function (k) {
      if (k === HARSH) {
        var hn = PHOTO_ONLY ? R.filter(function (r) { return r.s <= 3; }).length
                            : (S.dist[3] || 0) + (S.dist[2] || 0) + (S.dist[1] || 0);
        if (hn >= (PHOTO_ONLY ? 2 : 3)) chips.push([HARSH, hn]);
        return;
      }
      var n = base[k] || 0;
      var min = PHOTO_ONLY ? (NEG[k] ? 1 : 2) : (NEG[k] ? 3 : 5);
      if (n >= min) chips.push([k, n]);
    });
    if (!PHOTO_ONLY && S.with_pics >= 5) chips.push(["写真つき", S.with_pics]);
    html += '<div class="yg-chips">' + chips.map(function (c, i) {
      return '<button type="button" class="yg-chip' + (i === 0 ? " on" : "") + '" data-t="' + esc(c[0]) + '">' +
        esc(c[0]) + (i === 0 ? "" : " <small>" + c[1] + "</small>") + "</button>";
    }).join("") + "</div>" +
    '<p class="yg-note">写真つきのお声をご紹介しています。話題でしぼれます</p>' +
    '<p class="yg-lead" style="display:none"></p>' +
    '<div class="yg-sort"><button type="button" data-s="reco" class="on">おすすめ</button>' +
    '<button type="button" data-s="new">あたらしい順</button></div>' +
    '<div class="yg-list"></div><div class="yg-morewrap"></div>';
    root.innerHTML =
      '<div class="yg-head"><h2>お客様の声</h2><div class="yg-headbar"></div></div>' +
      '<p class="yg-headsub">' + S.total + "人の飼い主さんから、ありがたいお声をいただきました。</p>" + html;

    root.querySelectorAll(".yg-drow").forEach(function (b) {
      b.addEventListener("click", function () {
        var s = Number(b.dataset.star);
        starSel = (starSel === s) ? 0 : s; shown = 4; syncDist(); render();
      });
    });
    root.querySelector(".yg-chips").addEventListener("click", function (e) {
      var c = e.target.closest(".yg-chip"); if (!c) return;
      root.querySelectorAll(".yg-chip").forEach(function (x) { x.classList.remove("on"); });
      c.classList.add("on"); topicSel = c.dataset.t; shown = 4; render();
    });
    root.querySelectorAll(".yg-sort button").forEach(function (b) {
      b.addEventListener("click", function () {
        root.querySelectorAll(".yg-sort button").forEach(function (x) { x.classList.remove("on"); });
        b.classList.add("on"); sort = b.dataset.s; shown = 4; render();
      });
    });
    var strip = root.querySelector(".yg-strip");
    if (strip) strip.addEventListener("click", function (e) {
      if (e.target.tagName !== "IMG") return;
      var ri = Number(e.target.dataset.ri);
      starSel = 0; topicSel = "写真つき"; shown = 999;
      root.querySelectorAll(".yg-chip").forEach(function (x) {
        x.classList.toggle("on", x.dataset.t === "写真つき"); });
      syncDist(); render();
      var want = R[ri];
      var target = null;
      root.querySelectorAll(".yg-list .yg-rev").forEach(function (el) {
        if (!target && el.innerHTML.indexOf(esc(want.a)) >= 0 &&
            el.innerHTML.indexOf(esc(jdate(want.d))) >= 0) target = el;
      });
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        target.classList.add("hl");
        setTimeout(function () { target.classList.remove("hl"); }, 1400);
      }
    });
    render();
    // カートボタンそばのミニ証明（買う瞬間に★4.7を見せる）。
    // 価格はMikawaya管理でクラスが無い→カート追加ボタンをアンカーにして、その直上に置く（2026-07-09修正）。
    try {
      var atc = document.querySelector(".add-to-cart, .product-form__submit, button[name='add'], [name='add']");
      if (atc && !document.querySelector(".yg-mini-proof")) {
        var mp = document.createElement("p");
        mp.className = "yg-mini-proof";
        mp.innerHTML = starbar(S.avg) + " <b>" + S.avg.toFixed(1) + "</b><u>" + S.total + "件の声を読む</u>";
        mp.addEventListener("click", function () {
          root.scrollIntoView({ behavior: "smooth", block: "start" }); });
        atc.parentNode.insertBefore(mp, atc);
      }
    } catch (e) {}

    // 悩み別ディープリンク（2026-07-09）: LP等から ?concern=water で来たら、その話題に絞ってレビューへスクロール
    try {
      var CONCERN = { water: "お水を飲まない子", eat: "食いつき", tummy: "お腹の調子",
        senior: "シニアの子", daily: "毎日の楽しみ", topping: "トッピング・あげ方",
        multi: "多頭飼い", price: "お値段のこと", honest: HARSH, photo: "写真つき" };
      var mm = (location.search.match(/[?&]concern=([^&#]+)/) || [])[1] || (location.hash.match(/concern=([^&]+)/) || [])[1];
      var key = mm ? decodeURIComponent(mm) : "";
      var topic = CONCERN[key] || key;   // 英語キー or 話題名そのものを許容
      var chips = [].slice.call(root.querySelectorAll(".yg-chip"));
      var hit = chips.filter(function (c) { return c.dataset.t === topic; })[0];
      if (topic && hit) {
        chips.forEach(function (x) { x.classList.remove("on"); });
        hit.classList.add("on"); topicSel = topic; starSel = 0; shown = 4; syncDist(); render();
        setTimeout(function () { root.scrollIntoView({ behavior: "smooth", block: "start" }); }, 350);
      }
    } catch (e) {}
  }

  fetch(root.dataset.src).then(function (r) { return r.json(); }).then(build)
    .catch(function () { var l = root.querySelector(".yg-loading"); if (l) l.textContent = "レビューを読み込めませんでした"; });
})();
